// extracted by mini-css-extract-plugin
export default {"base":"vp_Q3Oqa","grid":"vp_I_ziA","reverse":"vp_dmbQ2","copy":"vp_jZxh1","eyebrow":"vp_gWEKF","title":"vp_oLt7w","text":"vp_Kvjr6","highlights":"vp_js_rk","highlight":"vp_m2p0C"};